import moment from "moment-timezone";
import { getPageContext } from "./page_context";

const timezoneAliases = {
  "Asia/Calcutta": "Asia/Kolkata",
};

export function localTZ() {
  const guess = moment.tz.guess();
  return timezoneAliases[guess] || guess;
}

export function userTZ() {
  const timezone = getPageContext()?.user?.timezone;
  return timezone || localTZ();
}

export function nowInTZ() {
  return moment().tz(userTZ());
}

export function inUserTZ(ts) {
  let time;
  if (typeof ts === "number") {
    time = moment.unix(ts);
  } else {
    time = moment(ts);
  }

  return time.tz(userTZ());
}

export function userFormat(removeTz = false) {
  let date_format = getPageContext()?.user?.date_format;
  let time_format = getPageContext()?.user?.time_format;

  if (removeTz) {
    time_format = time_format?.replace(/ Z/, "");
  }

  const userDateFormat = date_format || "l";
  const userTimeFormat = time_format || (removeTz ? "LT" : "LT Z");

  return `${userDateFormat}, ${userTimeFormat}`;
}

export function formatToUser(time, removeTz = false) {
  return time.format(userFormat(removeTz));
}

/**
 * Will hard-shift a string timestamp so that, if rendered in current timezone,
 * it will look as it is instead into the desired timezone.
 */
export function utcToZonedTime(utcTime) {
  const ourTimezone = localTZ();
  const ourOffsetInMillis =
    moment.utc(utcTime).tz(ourTimezone).utcOffset() * 60000;
  const givenTimezoneOffsetInMillis =
    moment.utc(utcTime).tz(userTZ()).utcOffset() * 60000;

  return moment.utc(utcTime) + givenTimezoneOffsetInMillis - ourOffsetInMillis;
}

/**
 * Will revert what utcToZonedTime had done.
 */
export function zonedTimeToUtc(zonedTime) {
  const ourTimezone = localTZ();
  const ourOffsetInMillis =
    moment.utc(zonedTime).tz(ourTimezone).utcOffset() * 60000;
  const givenTimezoneOffsetInMillis =
    moment.utc(zonedTime).tz(userTZ()).utcOffset() * 60000;

  return moment(zonedTime) - givenTimezoneOffsetInMillis + ourOffsetInMillis;
}
